<div class="app-layout" [class.role-admin]="userRole === 'ADMIN'">
  <app-confirm-dialog></app-confirm-dialog>
  <app-sidebar></app-sidebar>
  <div class="main-content" [class.collapsed]="isSidebarCollapsed">
    <header class="app-header">
      <div class="header-left">
        <button class="icon-btn mobile-menu-btn" aria-label="Open menu" (click)="openMobileSidebar()">
          <hugeicons-icon [icon]="menuIcon" [size]="22" color="currentColor"></hugeicons-icon>
        </button>
        <app-breadcrumb></app-breadcrumb>
      </div>
    </header>

    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>

  @if (enquiryState.selectedEnquiry$ | async; as enquiry) {
    <app-case-enquiry-details [enquiry]="enquiry"
      (close)="closeEnquiryDetails()">
    </app-case-enquiry-details>
  }
</div>
